import React from 'react';
import { Box, Typography } from '@mui/material';

const VideoStatus = ({ currentFrame, totalFrames, currentTime, totalTime }) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      px: 2, 
      py: 1, 
      bgcolor: 'grey.800', 
      color: 'grey.100' 
    }}>
      <Typography variant="body2">
        Frame: {currentFrame} / {totalFrames} ({Math.floor(currentFrame / totalFrames * 100)}%)
      </Typography>
      <Typography variant="body2">
        Time: {currentTime} / {totalTime}
      </Typography>
    </Box>
  );
};

export default VideoStatus;